<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <vue-headful :title="(jsa_id ? 'Edit' : 'Create') + ' [JSA] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jsa`">
                            <i class="fa fa-files-o"></i> JSA
                        </router-link>
                    </li>
                    <template v-if="jsa.jsa_id">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/jsa/view/${jsa.jsa_id}`">
                                {{ jsa.jsa_name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            <i class="fa fa-edit"></i> Edit
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active">
                            <i class="fa fa-plus-circle"></i> New JSA
                        </li>
                    </template>
                </ol>
            </h4>

            <template v-if="create_type === 'new'">
                <button type="button" class="btn btn-sm btn-success" v-on:click="generateJsa(this)" :disabled="saving"><i class="fa fa-file-excel-o"></i> Generate</button>
                <button type="button" class="btn btn-sm btn-primary btn-save" v-on:click="saveJsa();" :disabled="saving"><i class="fa fa-save"></i> Save For Later</button>
                <hr/>
            </template>

            <div class="row">
                <div class="col-xl-9 col-lg-10 col-md-12 mb-4">

                    <div class="card" v-if="templates.length > 0 && create_type === null">
                        <div class="card-header">Create From Template:</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">JSA Template:</label>
                                <div class="col-sm-8">
                                    <b-form-select v-model="jsa_template_id" :options="templateOptions"></b-form-select>

                                    <button class="btn btn-sm btn-success mt-2" :disabled="(jsa_template_id == null || cloning ? true : false)" v-on:click="cloneTemplate()">Create From Template</button>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Or Create From Blank JSA:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="create_type" value="new" :unchecked-value="null" plain></b-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="create_type === 'new'">
                        <div class="card mb-3">
                            <div class="card-header">
                                General Information
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_name}">JSA Name: <i class="fa fa-asterisk small text-danger"></i></label>
                                    <div class="col-sm-8">

                                       <b-form-input type="text" v-model="jsa.jsa_name" :class="{'is-invalid': errors.jsa_name}" placeholder="JSA Name"></b-form-input>

                                        <span v-if="errors.jsa_name" class="text-danger">
                                            <span v-for="error in errors.jsa_name">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.JobsiteId }" class="row">
                                    <label :class="{'text-danger': errors.JobsiteId}"class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Jobsite Name: <i class="fa fa-asterisk small text-danger"></i></label>
                                    <div class="col-sm-8">
                                        <jobsite-select :selectedValues="SiteSelectedValues" v-on:vselected="onJobSiteSelectUpdate"></jobsite-select>
                                        <span v-if="errors.JobsiteId" class="text-danger">
                                            <span v-for="error in errors.JobsiteId">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.jsa_date }" class="row">
                                    <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Date: <i class="fa fa-asterisk small text-danger"></i></label>
                                    <div class="col-sm-8">
                                        <date-picker v-model="jsa.jsa_date_formatted" @dp-change="datePickerChanged" :config="options"></date-picker>
                                        <span v-if="errors.jsa_date" class="text-danger">
                                            <span v-for="error in errors.jsa_date">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.jsa_contractor }" class="row">
                                    <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Contractor:</label>
                                    <div class="col-sm-8">
                                        <input type="text" name="jsa_contractor" v-model="jsa.jsa_contractor" class="form-control" placeholder="Enter Contractor" />
                                        <span v-if="errors.jsa_contractor" class="text-danger">
                                            <span v-for="error in errors.jsa_contractor">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Total # Of Steps:</label>
                                    <div class="col-sm-8">
                                        {{ steps.length }}
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Total # Of Hazards:</label>
                                    <div class="col-sm-8">
                                        {{ totalHazards }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-card>
                            <template slot="header">Safety Description</template>

                            <div class="form-group row">
                                <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_building_area}">Building/Area:</label>
                                <div class="col-sm-8">

                                    <b-form-textarea v-model="jsa.jsa_building_area" :class="{'is-invalid': errors.jsa_building_area}" rows="3" placeholder="Enter Building/Area Details"></b-form-textarea>

                                    <span v-if="errors.jsa_building_area" class="text-danger">
                                        <span v-for="error in errors.jsa_building_area">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_description}">Description of Work:</label>
                                <div class="col-sm-8">

                                    <b-form-textarea v-model="jsa.jsa_description" :class="{'is-invalid': errors.jsa_description}" rows="3" placeholder="Enter Description of Work"></b-form-textarea>

                                    <span v-if="errors.jsa_description" class="text-danger">
                                        <span v-for="error in errors.jsa_description">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_safety_equipment}">Standard PPE:</label>
                                <div class="col-sm-8">

                                    <b-form-textarea v-model="jsa.jsa_safety_equipment" :class="{'is-invalid': errors.jsa_safety_equipment}" rows="3" placeholder="Enter Standard PPE"></b-form-textarea>

                                    <span v-if="errors.jsa_safety_equipment" class="text-danger">
                                        <span v-for="error in errors.jsa_safety_equipment">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_specialized_equipment}">Specialized PPE:</label>
                                <div class="col-sm-8">

                                    <b-form-textarea v-model="jsa.jsa_specialized_equipment" :class="{'is-invalid': errors.jsa_specialized_equipment}" rows="3" placeholder="Enter Specialized PPE"></b-form-textarea>

                                    <span v-if="errors.jsa_specialized_equipment" class="text-danger">
                                        <span v-for="error in errors.jsa_specialized_equipment">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_monitoring_act}">Monitoring Activities:</label>
                                <div class="col-sm-8">

                                    <b-form-textarea v-model="jsa.jsa_monitoring_act" :class="{'is-invalid': errors.jsa_monitoring_act}" rows="3" placeholder="Enter Monitoring Activities"></b-form-textarea>

                                    <span v-if="errors.jsa_monitoring_act" class="text-danger">
                                        <span v-for="error in errors.jsa_monitoring_act">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </b-card>
                    </template>
                </div>
            </div>

            <template v-if="create_type === 'new'">
                <button type="button" class="btn btn-sm btn-success" v-on:click="generateJsa(this)" :disabled="saving"><i class="fa fa-file-excel-o"></i> Generate</button>
                <button type="button" class="btn btn-sm btn-primary btn-save" v-on:click="saveJsa();" :disabled="saving"><i class="fa fa-save"></i> Save For Later</button>
                <hr/>
            </template>

            <div class="mt-4" v-if="create_type === 'new'">
                <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                    <b-nav-item :active="curTab === 'job_steps'" @click="curTab = 'job_steps'">
                        <i class="fa fa-sitemap"></i> Job Steps ({{ steps.length }})
                        <b-button variant="success" size="xs" title="Add a New JSA Step" v-on:click="newStep()"><i class="fa fa-plus-circle"></i> Step</b-button>
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'employees'" @click="curTab = 'employees'">
                        <i class="fa fa-group"></i> Employees ({{ jsa_employees.length }})
                    </b-nav-item>
                </ul>

                <div class="mb-2 mb-lg-0 d-lg-none d-inline-block">
                  <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                        <b-dropdown-item :active="curTab === 'job_steps'" @click="curTab = 'job_steps'">
                            <i class="fa fa-sitemap"></i> Job Steps ({{ steps.length }})
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'employees'" @click="curTab = 'employees'">
                            <i class="fa fa-group"></i> Employees ({{ jsa_employees.length }})
                        </b-dropdown-item>
                  </b-dropdown>
                </div>

                <div class="d-lg-none d-inline-block" v-show="curTab === 'job_steps'">
                    <button class="btn btn-success" v-on:click="newStep()"><i class="fa fa-plus-circle"></i> Step</button>
                </div>

                <div class="mt-2">
                    <div v-show="curTab === 'job_steps'">
                        <div v-if="errors.jsa_steps" class="alert alert-danger">
                            Some steps failed validation.
                            <ul>
                                <li v-for="errors in errors.jsa_steps">{{ errors }}</li>
                            </ul>
                        </div>

                        <div class="card mb-3" v-for="(step, index) in steps" :key="index">
                            <div class="card-header">
                                <div class="form-inline">

                                    <div class="form-group mr-2">
                                        <b-button variant="danger" size="sm" v-on:click="deleteStep(index)" title="Delete Step"><i class="fa fa-trash"></i> Step</b-button>
                                    </div>
                                    <div class="form-group mr-2">
                                        <b-button variant="secondary" size="sm" v-on:click="newStepHazard(index)" title="Add a Hazard to a Step"><i class="fa fa-plus-circle"></i> Hazard</b-button>
                                    </div>

                                    <div class="form-group mr-2">
                                        <label class="ml-1 mr-1" :class="{'text-danger': errors['jsa_steps.'+index+'.step_label']}">Step Name:</label>
                                        <b-form-input :class="{'is-invalid': errors['jsa_steps.'+index+'.step_label']}" v-model="step.step_label" style="width: 300px;" size="sm" placeholder="Enter Step Name"></b-form-input>
                                    </div>

                                    <div class="form-group mr-2">
                                        # of Hazards: ({{ step.hazards.length }})
                                    </div>

                                    <span v-if="errors['jsa_steps.'+index+'.step_label']" class="text-danger">
                                        &nbsp;<span v-for="error in errors['jsa_steps.'+index+'.step_label']">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="card-body">
                                <template v-for="(haz, hIndex) in step.hazards">
                                    <hr v-if="hIndex > 0" />
                                    <div class="border border-light bg-light py-3 px-4">
                                        <div class="form-inline mb-2">
                                            <div class="form-group mr-3">
                                                <b-button variant="danger" size="xs" v-on:click="deleteStepHazard(index, hIndex)" title="Delete Hazard"><i class="fa fa-trash"></i></b-button>
                                            </div>
                                            <div class="form-group mr-3">
                                                <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.hazard']}" class="mr-1">Hazard:</label>
                                                <b-form-select :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.hazard']}" :options="selectHazards" v-model="haz.hazard" size="sm"></b-form-select>
                                                <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.hazard']" class="text-danger">
                                                    &nbsp;<span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.hazard']">{{ error }}</span>
                                                </span>
                                            </div>
                                            <div class="form-group">
                                                <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.rac_level']}" class="mr-1">RAC Level:</label>
                                                <b-form-select :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.rac_level']}" :options="selectRacLevels" v-model="haz.rac_level" size="sm"></b-form-select>
                                                <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.rac_level']" class="text-danger">
                                                    <span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.rac_level']">{{ error }}</span>
                                                </span>
                                            </div>
                                        </div>
                                        <hr />

                                        <div class="form-group">
                                            <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.controls']}" class="mr-1">Standard Controls:</label>
                                            <!-- is-invalid doesn't work on multiselect? It puts it on there but does nothing -->
                                            <multiselect :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.controls']}" v-model="haz.controls" :options="controls" :multiple="true" :taggable="true" group-label="hazard_name" group-values="children" :group-select="false"></multiselect>
                                            <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.controls']" class="text-danger">
                                                <span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.controls']">{{ error }}</span>
                                            </span>

                                        </div>
                                        <div class="form-group">
                                            <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.has_other_controls']}" class="mr-1">Other Controls:</label>
                                            <b-form-radio-group :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.has_other_controls']}" plain v-model="haz.has_other_controls">
                                                <b-form-radio value="1">Yes</b-form-radio>
                                                <b-form-radio value="0">No</b-form-radio>
                                            </b-form-radio-group>
                                            <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.has_other_controls']" class="text-danger">
                                                <span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.has_other_controls']">{{ error }}</span>
                                            </span>
                                        </div>
                                        <div class="form-group" v-if="haz.has_other_controls == 1">
                                            <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.other_controls']}">Other Controls</label>
                                            <b-form-textarea :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.other_controls']}" v-model="haz.other_controls" rows="2" placeholder="Enter Other Controls"></b-form-textarea>
                                            <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.other_controls']" class="text-danger">
                                                <span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.other_controls']">{{ error }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div v-show="curTab === 'employees'">
                        <div class="row">
                            <div class="col-lg-7 mb-lg-0 mb-3">
                                <div class="card">
                                    <div class="card-header">Add Employees:</div>
                                    <div class="card-body">
                                        <employee-select ref="jsaEmpSelector" @vselected="jsaEmpSelect"></employee-select>

                                        <div class="mt-2">
                                            <ol class="list-unstyled">
                                                <li v-for="(emp, i) in jsa_employees">
                                                    <button class="btn btn-xs btn-link" v-on:click="removeEmployee(emp)"><span class="text-danger"><i class="fa fa-trash"></i></span></button>
                                                    {{ emp.FirstName }} {{ emp.LastName }}
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-5" v-if="lastEmployeeOptions.length > 0">
                                <div class="card">
                                    <div class="card-header">Add Employees from Last JSA:</div>
                                    <div class="card-body">
                                        <div class="mb-3">
                                            <button class="btn btn-sm btn-info" v-on:click="addAllLastEmployees()"><i class="fa fa-plus-circle"></i> Add All {{ lastEmployeeOptions.length }} Recent Employees</button>
                                        </div>

                                        <div v-for="(emp, i) in lastEmployeeOptions" :key="emp.EmployeeId" class="mt-2">
                                            <button class="btn btn-xs btn-success" v-on:click="jsaEmpSelect(emp)"><i class="fa fa-plus-circle"></i></button> {{ emp.FirstName }} {{ emp.LastName }} - {{ emp.EmployeeNumber }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data: function() {
        return {
            loading: true,
            saving: false,
            cloning: false,
            curTab: 'job_steps',
            errors: {},
            jsa_id: this.$route.params.id,
            jsa: {},
            steps: [],
            hazards: [],
            controls: [],
            racLevels: [],
            JobsiteId: 0,
            options: {
                format: 'MM/DD/YYYY',
                date: ""
            },

            create_type: null,
            jsa_template_id: null,
            templates: [],

            jsa_employees: [],
            last_employees: [],

            settingsTabs: {
                job_steps: 'Job Steps',
                employees: 'Employees',
            },

        }
    },

    computed: {

        selectHazards(){
            //Setup
            var options = [
                {value: null, text: '-- Select a Hazard --'},
            ];

            //Loop
            for(var i in this.hazards)
            {
                options.push({value: this.hazards[i], text: this.hazards[i]});
            }

            //SEnd it
            return options;
        },

        selectRacLevels(){
            //Setup
            var options = [
                {value: null, text: '-- Select an RAC Level --'},
            ];

            //Loop
            for(var i in this.racLevels)
            {
                options.push({value: this.racLevels[i], text: this.racLevels[i]});
            }

            //SEnd it
            return options;
        },

        SiteSelectedValues(){
            //check for null
            if(!this.jsa.JobsiteId || this.jsa.JobsiteId == null)
            {
                //Check the store
                if(this.$store.state.user.jobsite)
                {
                    var jobsite = this.$store.state.user.jobsite;

                    //Set the HSE jobsite
                    this.jsa.JobsiteId = jobsite.JobsiteId;

                    //Send it
                    return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                }

                //Send it
                return null;
            }

            //Send it
            return {JobsiteId: this.jsa.JobsiteId, JobsiteNumber: this.jsa.JobsiteNumber, JobsiteName: this.jsa.JobsiteName};
        },

        totalHazards(){
            //Start it
            var t = 0;

            //Loop and count
            for (var i = this.steps.length - 1; i >= 0; i--)
            {
                t += this.steps[i].hazards.length;
            }

            //Send it
            return t;
        },

        templateOptions(){
            //Setup
            var options = [
                {value: null, text: '-- Select a JSA Template --'},
            ];

            //Loop
            for(var i = 0; i < this.templates.length; i++)
            {
                options.push({value: this.templates[i].jsa_id, text: this.templates[i].jsa_name});
            }

            //SEnd it
            return options;
        },

        tabButtonTitle(){
            //Send it
            var html = this.settingsTabs[this.curTab];

            //Switch
            switch(this.curTab)
            {
                case 'job_steps':
                    //Append Count
                    html = '<i class="fa fa-sitemap"></i> ' + this.settingsTabs[this.curTab] + '('+this.steps.length+')';
                    break;

                case 'employees':
                    //Append Count
                    html = '<i class="fa fa-group"></i> ' + this.settingsTabs[this.curTab] + '('+this.jsa_employees.length+')';
                    break;
            }

            //Send it
            return html;
        },

        lastEmployeeOptions(){
            //Build the Array
            var emps = [];

            for(var i = 0; i < this.last_employees.length; i++)
            {
                //Setup
                var exists = false;

                //Check if Already Added
                for(var j = 0; j < this.jsa_employees.length; j++)
                {
                    //Compare
                    if(this.jsa_employees[j].EmployeeId == this.last_employees[i].EmployeeId)
                    {
                        //Continue 2?
                        var exists = true;

                        //Stop here
                        break;
                    }
                }

                //Add it
                if(!exists)
                {
                    emps.push(this.last_employees[i]);
                }
            }

            //Send it
            return emps;
        }

    },


    methods: {

        getGenerate() {
            //Get the data
            this.$http
                .get('jsa/create' + (this.jsa_id ? '/' + this.jsa_id : ''))
                .then(response => {
                    //Set all the data
                    this.jsa = response.data.jsa;
                    this.types = response.data.types
                    this.steps = response.data.jsa.jsa_steps;

                    //Create default first step
                    if(this.steps.length == 0)
                    {
                        this.newStep();
                    }

                    //Resources Used by the Steps
                    this.hazards = response.data.hazards;
                    this.controls = response.data.controls;
                    this.racLevels = response.data.racLevels;
                    this.templates = response.data.templates;
                    this.jsa_employees = response.data.jsa_employees;
                    this.last_employees = response.data.last_employees;

                    //Check for Templates
                    if(this.templates.length == 0 || this.jsa.jsa_id)
                    {
                        //Set the type
                        this.create_type = 'new';
                    }

                    //Set loading
                    this.loading = false;
                })
                .catch(err => {
                    //Log the error
                    console.log(err);
                });
        },

        generateJsa() {

            //Call the save function, but pass in generate
            this.saveJsa('generate');
        },

        saveJsa(routeString = 'edit') {
            //SHow loading
            this.saving = true;

            //Reset the errors
            this.errors = {};

            //Set the JSA steps before sending
            this.jsa.jsa_steps = this.steps;

            //Set Up
            this.jsa.jsa_employees = this.jsa_employees;

            //Send it
            this.$http
                .post('jsa/' + routeString, this.jsa)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('JSA Saved' + (routeString != 'edit' ? ' and Generated' : ''));

                    //Return to main list?
                    this.$router.push('/jsa/view/' + response.data.jsa_id);
                })
                .catch(error => {
                    //Check for error
                    if (error.response.status === 422) {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
        },

        cloneTemplate(){
            //Send it
            this.cloning = true;

            //Send it
            this.$http
                .post('/jsa/clone/' + this.jsa_template_id)
                .then(response => {
                    //Return to main list?
                    this.$router.push('/jsa/edit/' + response.data.jsa_id);
                })
                .catch(response => {

                })
                .then(response => {
                    //Rest
                    this.cloning = false;
                });
        },

        onJobSiteSelectUpdate (jobsite) {
                //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.jsa.JobsiteId = null;
                    return;
                }

                //Send the value
                this.jsa.JobsiteId = jobsite.JobsiteId;
                //this.incident.JobsiteName = jobsite.JobsiteName;
                //this.incident.JobsiteNumber = jobsite.JobsiteNumber;
            },

        newStep(){
            //Get the length
            var index = this.steps.length;

            //Push a new array
            this.steps.push({step_label: '', hazards: []});

            //Create the new hazard
            this.newStepHazard((index));
        },

        deleteStep(index){
            //Confirm it
            if(!confirm('Are you sure you want to delete this step?'))
            {
                return;
            }

            //Slice Out
            this.steps.splice(index, 1);
        },

        newStepHazard(stepIndex){
            //Loop and push
            for (var i = this.steps.length - 1; i >= 0; i--)
            {
                //Check the index
                if(i === stepIndex)
                {
                    this.steps[i].hazards.push({hazard: null, rac_level: null, has_other_controls: 0, controls: [],});
                }
            }
        },

        deleteStepHazard(stepIndex, hazardIndex){
            //Slice Out
            this.steps[stepIndex].hazards.splice(hazardIndex, 1);
        },

        addAllLastEmployees(){
            //Add all
            for (var i = this.last_employees.length - 1; i >= 0; i--)
            {
                //Call the helper
                this.jsaEmpSelect(this.last_employees[i]);
            }
        },

        jsaEmpSelect(employee){
            if (employee == null)
            {
                return;
            }

            //Reset
            this.$refs.jsaEmpSelector.clearInput();

            //ONLY add if not alredy exists
            for (var i = this.jsa_employees.length - 1; i >= 0; i--)
            {
                //Call the helper
                if(this.jsa_employees[i].EmployeeId == employee.EmployeeId)
                {
                    //Stop Function
                    return;
                }
            }

            //Add
            this.jsa_employees.push(employee);
        },

        removeEmployee(employee){
            //Loop and Remove
            for (var i = this.jsa_employees.length - 1; i >= 0; i--)
            {
                //Call the helper
                if(this.jsa_employees[i].EmployeeId == employee.EmployeeId)
                {
                    //Remove and Stop
                    this.jsa_employees.splice(i, 1);

                    //IF there is a primary key ID (id), then AJAX delete it silently
                    if(this.jsa.jsa_id && employee.pivot)
                    {
                        //Call the Helper Function
                        this.deleteJsaEmployee(employee.pivot.id);
                    }

                    //Stop
                    break;
                }
            }
        },

        deleteJsaEmployee(jsa_employee_id){
            //Send it
            this.$http
                .delete('jsa/employees/' + jsa_employee_id)
                .then(response => {
                    //Do nothing
                })
                .catch(error => {
                    //Log
                    console.log(error.response.data);
                })
                .then(response => {

                });
        },

        datePickerChanged ( data ) {
            // Stringify datePicked
            var dateParts = data.target.value.split("/");

            //Send it
            this.jsa.jsa_date = dateParts[2]+'-'+dateParts[0]+'-'+dateParts[1];
        },

    },

    mounted() {
        this.getGenerate();
    },

}
</script>
<style>
    .form-inline .multiselect {
        display: inline-block;
        width: auto;
    }
</style>